module.exports = {
	ok: gettext('Ok'),
	cancel: gettext('Cancel')
};
